export const AI_AGENTS_PLATFORM_PAGE = {
  path: '/ai-agents-platform',
  hero: {
    chapter: 'Глава 01',
    title: 'Память компании\nи команда агентов',
    subtitle: 'AI-based база данных и агенты — в одном контуре',
    cta: 'Обсудить внедрение',
    itmoSticker: {
      logo: '/images/partners/itmo-logo.png',
      logoAlt: 'Университет ИТМО',
      caption: 'Партнер с 2018 года',
    },
  },
  problem: {
    chapter: 'Глава 02',
    title: 'Знания есть.\nИспользовать их — нет',
    lines: [
      'Регламенты в десяти хранилищах.',
      'Ответы — в головах экспертов.',
      'Рутина съедает неделю.',
    ],
  },
  foundation: {
    chapter: 'Глава 03',
    title: 'AI-based\nбаза данных',
    tag: 'RAG',
    lead: 'Корпоративная память: документы, CRM, wiki, тикеты — в одном индексе с доступом по ролям.',
    bullets: ['Ответ со ссылкой на источник', 'On-premise или облако', 'Основа для всех агентов'],
    image: '/images/corporate-rag.png',
    imageAlt: 'Корпоративная AI-based база данных — поиск по документам и системам',
  },
  memoryTeam: {
    chapter: 'Глава 04',
    title: 'Результаты работы\nи встреч в общей базе',
    memory: {
      title: 'Структура памяти агентов',
      layers: [
        {
          id: 'short-term',
          label: 'Кратковременная (рабочая)',
          text: 'Удерживает текущий контекст задачи и связность прямого диалога в рамках одной сессии.',
        },
        {
          id: 'long-term',
          label: 'Долговременная',
          text: 'Накапливает профильные предпочтения, корпоративные регламенты и историю прошлых проектов — агенты обучаются и не повторяют ошибки.',
        },
      ],
    },
    hybridTeam: {
      title: 'Ключевые функции «гибридной» команды',
      functions: [
        {
          id: 'routine',
          title: 'Освобождение людей от рутины',
          text: 'Агенты берут на себя технический шум — передачу статусов, поиск ссылок, сборку отчётов. Человек сосредотачивается на эмоциях, мотивации и управленческих решениях.',
        },
        {
          id: 'sync',
          title: 'Синхронизация отделов',
          text: 'Память служит «переводчиком» между контекстом специалистов — от разработчиков до маркетологов — и выравнивает понимание единой бизнес-цели.',
        },
        {
          id: 'continuity',
          title: 'Непрерывность',
          text: 'Если один агент завершает задачу, следующий считывает из общей памяти накопленные детали без потери важного контекста пользователя.',
        },
      ],
    },
  },
  agentsIntro: {
    chapter: 'Глава 05',
    title: 'Четыре агента.\nОдна команда',
    subtitle: 'Каждый закрывает свой контур — данные из общей базы знаний',
  },
  agents: [
    {
      id: 'outreach',
      chapter: '05.1',
      name: 'Аутрич-агент',
      tagline: 'Персональный выход на рынок',
      lead: 'Ищет контакты, собирает контекст, готовит письма и follow-up — по вашим правилам и тону бренда.',
      outcome: 'Больше релевантных касаний — меньше ручной подготовки',
      icon: 'Send',
      accent: 'gradient-deeptech',
    },
    {
      id: 'strategic',
      chapter: '05.2',
      name: 'Стратегический агент',
      tagline: 'Сводки для руководства',
      lead: 'Собирает сигналы из отчётов и рынка, строит сценарии и короткие executive summary для решений.',
      outcome: 'Стратегия на данных — не на догадках',
      icon: 'Compass',
      accent: 'gradient-alert',
    },
    {
      id: 'project',
      chapter: '05.3',
      name: 'Проектный агент',
      tagline: 'Статус и риски проекта',
      lead: 'Читает CRM, письма и документы, обновляет статусы, напоминает о дедлайнах и блокерах.',
      outcome: 'Проекты под контролем без микроменеджмента',
      icon: 'FolderKanban',
      accent: 'gradient-update',
    },
    {
      id: 'helpdesk',
      chapter: '05.4',
      name: 'Хелпдеск-агент',
      tagline: 'Первая линия поддержки',
      lead: 'Отвечает по базе знаний, эскалирует сложное в Service Desk, фиксирует обращения.',
      outcome: 'Сотрудники получают ответ за минуты',
      icon: 'Headphones',
      accent: 'gradient-install',
    },
  ],
  flow: {
    chapter: 'Глава 06',
    title: 'Как это\nработает вместе',
    steps: [
      { label: '01', text: 'Сотрудник задаёт задачу' },
      { label: '02', text: 'База данных находит контекст' },
      { label: '03', text: 'Агент действует в системах' },
      { label: '04', text: 'Результат и источник — в отчёте' },
    ],
    example:
      'Пользователь пишет в чат агенту — стратегический агент изучает документы и планы компании, проектный агент обновляет статус по задачам, хелпдеск закрывает типовые вопросы команды.',
  },
  integrations: {
    chapter: 'Глава 07',
    title: 'Интеграция\nс корпоративными системами',
    subtitle: 'Всё, что нужно для автоматизации бизнеса и работы',
    lead: 'Агенты подключаются к CRM, ERP, мессенджерам и внутренним API — без долгой разработки интеграций с нуля.',
    serviceCount: '1 000+',
    serviceCountLabel: 'сервисов',
    highlights: [
      {
        value: '1 000+',
        title: 'Интеграция с сервисами',
        text: 'Связка агентов с CRM, аналитикой, рекламой и мессенджерами через платформу — без программистов.',
      },
      {
        value: 'API',
        title: 'Любые корпоративные системы',
        text: 'Кастомные коннекторы, вебхуки и HTTP-запросы — подключим внутренние API и legacy-системы в вашем контуре.',
      },
      {
        value: '5 мин',
        title: 'Быстрый старт',
        text: 'Типовые сценарии — заявка из формы в CRM, статус в тикетах, ответ из базы знаний — настраиваются за минуты.',
      },
    ],
    platform: {
      title: 'Платформа',
      text: 'Интеграционная платформа — no-code связка агентов с 1 000+ приложениями. Данные в РФ, 152-ФЗ.',
    },
  },
  teamTasks: {
    chapter: 'Глава 08',
    title: 'ИИ-агенты под задачи\nвашей команды',
    subtitle: 'Маркетинг, продажи, поддержка: агент встраивается в любой процесс',
    items: [
      {
        id: 'marketing',
        name: 'Маркетинг',
        text: 'Распределяйте лиды из ВКонтакте и Яндекс Директа в CRM. Агент оценивает каждый лид по вашим критериям и передаёт горячие контакты в отдел продаж за минуты.',
        icon: 'Megaphone',
      },
      {
        id: 'sales',
        name: 'Продажи',
        text: 'Когда приходит новый лид, агент находит контакт в базе, создаёт или обновляет сделку в amoCRM или Битрикс24 и отправляет напоминания менеджерам в зависимости от стадии сделки.',
        icon: 'BadgeDollarSign',
      },
      {
        id: 'support',
        name: 'Поддержка',
        text: 'Когда в Usedesk или Omnidesk поступает тикет, агент сортирует его по срочности, сверяется с вашей базой знаний и готовит первый ответ. Важные обращения сразу попадают к нужному специалисту.',
        icon: 'LifeBuoy',
      },
      {
        id: 'orchestration',
        name: 'Оркестрация',
        text: 'Синхронизируйте данные между CRM, проектными инструментами и таблицами. Агент отмечает несовпадения и отправляет структурированные сводки в Google Sheets для еженедельного отчёта.',
        icon: 'Workflow',
      },
    ],
  },
  roi: {
    chapter: 'Глава 09',
    title: 'Экономическая\nвыгода',
    lead: 'Агент позволяет освободить до 40 часов в месяц на каждого сотрудника.',
    roles: [
      { id: 'top', label: 'Топ-менеджер', monthlyValue: 75000 },
      { id: 'senior', label: 'Старший сотрудник', monthlyValue: 50000 },
      { id: 'line', label: 'Линейный специалист', monthlyValue: 25000 },
    ],
    company: {
      title: 'Расчёт на компанию',
      headcount: [
        { roleId: 'top', label: 'Топ-менеджеры', count: 3 },
        { roleId: 'senior', label: 'Старшие сотрудники', count: 10 },
        { roleId: 'line', label: 'Линейные специалисты', count: 100 },
      ],
    },
    payback: {
      headline: 'Окупаемость — 1 месяц',
      note: 'Без учёта стоимости лицензий на софт и инфраструктуру',
    },
  },
  cases: {
    hidden: true,
    chapter: 'Глава 10',
    title: 'Кейсы\nна видео',
    subtitle: 'Как команда агентов работает в реальных процессах',
    items: [
      {
        title: 'Аутрич и CRM',
        caption: 'Персонализация писем и фиксация касаний в CRM без ручного копирования.',
        embedUrl: '',
        isMock: true,
        poster: '/images/corporate-ai-agent.png',
      },
      {
        title: 'База знаний и хелпдеск',
        caption: 'Ответы по регламентам со ссылкой на источник — первая линия без очереди.',
        embedUrl: '',
        isMock: true,
        poster: '/images/corporate-rag.png',
      },
      {
        title: 'On-prem контур',
        caption: 'Агенты и RAG в периметре компании — данные не уходят наружу.',
        embedUrl: '',
        isMock: true,
        poster: '/images/ai-on-prem.png',
      },
    ],
  },
  deploy: {
    chapter: 'Глава 11',
    title: 'От пилота\nдо SLA',
    steps: [
      { title: 'Аудит', text: 'Процессы, данные, ИБ' },
      { title: 'Пилот', text: '1–2 агента + база' },
      { title: 'Масштаб', text: 'Команда агентов' },
      { title: 'SLA', text: 'Сопровождение ЦБР' },
    ],
    cta: 'Запросить пилот',
  },
  faq: [
    {
      q: 'Чем AI-based база данных отличается от обычного поиска?',
      a: 'Она отвечает на вопрос фрагментами из ваших документов и систем со ссылкой на источник — а не списком файлов.',
    },
    {
      q: 'Можно внедрить только одного агента?',
      a: 'Да. Старт с базы знаний и хелпдеска — типичный пилот. Остальных агентов подключаем по мере готовности процессов.',
    },
    {
      q: 'Где разворачивается решение?',
      a: 'Облако, частное облако или on-premise — по требованиям ИБ и 152-ФЗ.',
    },
  ],
  relatedPage: {
    label: 'Все ИИ-услуги',
    href: '/services',
    text: 'Агенты, AI-based база данных (RAG), on-prem — полный каталог внедрения ИИ.',
  },
};

export function getRoleMonthlyValue(roi, roleId) {
  return roi.roles.find((role) => role.id === roleId)?.monthlyValue ?? 0;
}

export function calculateMonthlySavings(roi) {
  return roi.company.headcount.reduce((total, row) => {
    return total + row.count * getRoleMonthlyValue(roi, row.roleId);
  }, 0);
}

export function formatRubles(amount) {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  }).format(amount);
}

export function buildAiAgentsPlatformStructuredData() {
  const base = 'https://antologia.tech';
  const url = `${base}${AI_AGENTS_PLATFORM_PAGE.path}`;
  const page = AI_AGENTS_PLATFORM_PAGE;

  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': `${base}/#organization`,
      name: 'Антология',
      url: base,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${url}#webpage`,
      url,
      name: 'Внедрение AI-based базы данных и команды ИИ-агентов',
      isPartOf: { '@id': `${base}/#website` },
      about: { '@id': `${base}/#organization` },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'AI-based база данных (RAG)',
      provider: { '@id': `${base}/#organization` },
      areaServed: 'RU',
      description: page.foundation.lead,
    },
    ...page.agents.map((agent) => ({
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: agent.name,
      provider: { '@id': `${base}/#organization` },
      areaServed: 'RU',
      description: agent.lead,
    })),
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: page.faq.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ];
}
